import { useEffect, useState } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import logo from '../Assets/png/astrohelm.png'
import instagram from '../Assets/png/icons8-instagram-48.svg'
import linkedin from '../Assets/png/icons8-linkedin-48.svg'
import twitter from '../Assets/png/icons8-twitter-48.svg'
export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);
    useEffect(
        () => 
        {
            const onScroll = () => {
                if (window.scrollY > 50)
                {
                    setScrolled(true);
                }
                else {
                    setScrolled(false);
                }
            }
            window.addEventListener("scrolled", onScroll);
            return () => window.removeEventListener("scrolled", onScroll);
        }, []
    )
    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }
    return(
        <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
            <Container>
               <Navbar.Brand href="home">
                <img src={logo} alt="Logo"/>
                </Navbar.Brand> 
                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <span className="navbar-toggler-icon"></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link href="#home" className={activeLink === 'home' ? 'activate navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
                        <Nav.Link href="#skills" className={activeLink === 'skills' ? 'activate navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
                        <Nav.Link href="#projects" className={activeLink === 'projects' ? 'activate navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Projects</Nav.Link>
                    </Nav>
                    <span className="navbar-text">
                        <div className="social-icon">
                            <a href="https://instagram.com/adnan_shelim?igshid=YmMyMTA2M2Y="><img src={instagram} alt="Instagram"/></a>
                            <a href="https://twitter.com/Adnan05272081"><img src={twitter} alt="Twitter"/></a>
                            <a href="https://www.linkedin.com/in/adnan-mohammed-648052269"><img src={linkedin} alt="Linkedin"/></a>
                        </div>
                        <a href="https://docs.google.com/document/d/1xixCzarKUbVMabCN-motuWi2I6cAVG9s/edit?usp=sharing&ouid=110016756995705062777&rtpof=true&sd=true" target="_blank" rel="noopener noreferrer">
                            <button className="vvd"><span>My Resume</span></button>
                        </a>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}